module.exports = __webpack_public_path__ + "img/lordsmobile.e734431.png";